const ORDER_STATUSES = {
  INITIAL_STATUS: 'NEW',
  NEW: {
    text: 'Pending',
    color: 'white'
  },
  IS_PROCESSING: {
    text: 'Is processing',
    color: 'gray'
  },
  WAITING_FOR_PAYMENT: {
    text: 'Is waiting for payment',
    color: '#FFF59D'
  },
  PAIED: {
    text: 'Paid',
    color: 'yellow'
  },
  BUILDING: {
    text: 'Is building',
    color: '#A5D6A7'
  },
  BUILT: {
    text: 'Built',
    color: 'green'
  },
  CANCELED: {
    text: 'Canceled',
    color: 'red'
  }
}
export default ORDER_STATUSES
